module.exports = __webpack_public_path__ + "static/media/karte-grey-1920x1200.84548844.jpg";